import * as Yup from 'yup';
import qs from 'qs';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Iconify from 'src/components/Iconify';
// material
import {
  Grid,
  TextField,
  Alert,
  Typography,
  Switch,
  Stack,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Autocomplete,
  FormHelperText,
  FormControlLabel,
  Card,
  colors,
  Icon,
  CircularProgress
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import React, {Fragment } from 'react';

// component
import PropTypes, { number } from 'prop-types';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import client from 'src/api/clients';
import { setAddDevice ,getServerList ,getTimezoneList, getCamerasList } from 'src/api/analytics';
import axios from 'src/axios';
import {setNewDevice ,putExistingDevice } from 'src/api/devices'
import { getClientProperties } from 'src/api/ShiftMaster';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const CAMERA_CONFIGURATION_FIELDS = [
  'CameraMake',
  'CameraModel',
  'LocalHTTPURL',
  'PublicHTTPURL',
  'HaveSpeaker'
];


export default function DeviceForm({ dialogData, setOpen, reloadClientsData ,handleReloadPage,isReseller}) {
    const [fullWidth, setFullWidth] = useState(true);
    const [maxWidth, setMaxWidth] = useState('md');
    const [clientDetails,setClient] = useState([]);
    const [serverDetails,setServer] = useState([]);
    const [timezoneDetails,setTimezone] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    // const [selectedClientId, setSelectedClientId] = useState('');
    // const [selectedServerId, setSelectedserverId] = useState('');
    // const [selectedTimezoneId, setSelectedtimezoneID] = useState('');
    const [originalFormDataList, setOriginalFormDataList] = useState([]);
    const [originalServerId, setOriginalServerId] = useState('');
    const [originalEventSendTo, setOriginalEventSendTo] = useState('');
    const [originalTimeZone, setOriginalTimeZone] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formDataList, setFormDataList] = useState([
      {
        clientid: '',
        locationid: '',
        CameraView: '',
        server_id: '',
        Serverport: '', 
        TimezoneId: '',
        MainStream: '',
        Category:'2',
        substream: '',
        ReStream: '',
        LocalDeviceName: '',
        devicename: '',
        fps: 8, 
        IsActive: 1,
        CameraMake: '',
        CameraModel: '',
        LocalHTTPURL: '',
        PublicHTTPURL: '',
        HaveSpeaker: 0,
        BeforeVideo:10,
        AfterVideo:60,
        BackupDurationDays: 15,
        Footage:1,
        IsAgentBased:1,
        EventsBackupDays: 15,
        EscalatedEventsBackupDays : 90,
        MonitoringStartDate : '',
        MonitoringEndDate : ''
      }
    ]);
    // console.log("Form data",formDataList)
    const [formErrors, setFormErrors] = useState({});
    const [saveClicked, setSaveClicked] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [locationOptionsByIndex, setLocationOptionsByIndex] = useState({});
    const [uniqueClientOptions, setUniqueClientOptions] = useState([]);

    const normalizeDisplayName = (name) =>
      String(name || '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase();

    const buildUniqueClientOptions = (clients) => {
      const grouped = new Map();

      clients.forEach((clientItem) => {
        const key = normalizeDisplayName(clientItem?.displayname);
        if (!key) return;

        const existing = grouped.get(key);
        if (!existing) {
          grouped.set(key, clientItem);
          return;
        }

        // Prefer root entry (AssignClient 0) as the representative option.
        if (Number(existing.AssignClient || 0) !== 0 && Number(clientItem.AssignClient || 0) === 0) {
          grouped.set(key, clientItem);
        }
      });

      return Array.from(grouped.values());
    };

    const getRelatedClientIds = (selectedClientId) => {
      const selectedClient = clientDetails.find((client) => Number(client.ID) === Number(selectedClientId));
      if (!selectedClient) return [];

      const selectedNameKey = normalizeDisplayName(selectedClient.displayname);
      if (!selectedNameKey) return [Number(selectedClientId)];

      const sameNameClients = clientDetails.filter(
        (client) => normalizeDisplayName(client.displayname) === selectedNameKey
      );

      if (sameNameClients.length <= 1) {
        return [Number(selectedClientId)];
      }

      const sameNameIds = new Set(sameNameClients.map((client) => Number(client.ID)));
      const hasAssignMapping = sameNameClients.some((client) => {
        const assignId = Number(client.AssignClient || 0);
        return assignId !== 0 && sameNameIds.has(assignId);
      });

      if (hasAssignMapping) {
        return Array.from(sameNameIds);
      }

      return [Number(selectedClientId)];
    };

    const fetchLocationsForClient = (selectedClientId, index) => {
      if (!selectedClientId) {
        setLocationOptionsByIndex((prev) => ({ ...prev, [index]: [] }));
        return;
      }

      const relatedClientIds = getRelatedClientIds(selectedClientId).filter((id) => !Number.isNaN(id));
      const assignClientParam = relatedClientIds.length > 1
        ? relatedClientIds.join(',')
        : relatedClientIds[0];

      getClientProperties({ AssignClient: assignClientParam }, (response) => {
        if (response.status === 200) {
          const normalizedLocations = Array.from(
            new Map(
              (Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []))
                .map((locationItem) => ({
                  ...locationItem,
                  ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
                  Location: String(locationItem?.Location || locationItem?.name || '').trim(),
                }))
                .filter((locationItem) => locationItem.ID > 0)
                .map((locationItem) => [locationItem.ID, locationItem])
            ).values()
          );
          setLocationOptionsByIndex((prev) => ({ ...prev, [index]: normalizedLocations }));
        } else {
          setLocationOptionsByIndex((prev) => ({ ...prev, [index]: [] }));
        }
      });
    };

    const hasLocationsForIndex = (index) => (locationOptionsByIndex[index] || []).length > 0;


    const schema = Yup.object().shape({
      clientid: Yup.string().required('Client is required'),
      server_id: Yup.string().required('Server is required'),
      // CameraView: Yup.string().required('Camera View is required'),
      devicename: Yup.string().required('Camera Name is required'),
      // Serverport: Yup.number().required('Server Port is required'),
      // MainStream: Yup.string().required('Main Stream is required'),
      substream: Yup.string().required('Sub Stream is required'),
      // ReStream: Yup.string().required('ReStream is required'),
      // LocalDeviceName: Yup.string().required('Local Camera Name is required'),
      // fps: Yup.number().required('Frames Per Second (fps) is required'),
      // CameraMake: Yup.string().required('Camera Make is required'),
      // CameraModel: Yup.string().required('Camera Model is required'),
      // LocalHTTPURL: Yup.string().required('Local HTTP URL is required'),
      // PublicHTTPURL: Yup.string().required('Public HTTP URL is required'),
      TimezoneId: Yup.string().required('Time Zone is required'),
      Footage: Yup.string().required('Footage is required'),
      IsAgentBased: Yup.string().required('Events Type is required'),
      EventsBackupDays:  Yup.string().required('Events Backup Days is required'),
      EscalatedEventsBackupDays :  Yup.string().required('EscalatedEvents Backup Days  is required'),
      BeforeVideo: Yup.number().typeError('Before Clip(Sec) is required').required('Before Clip(Sec) is required'),
      AfterVideo: Yup.number().typeError('After Clip(Sec) is required').required('After Clip(Sec) is required'),
      // archieve: Yup.boolean(),
      // BackupDurationDays: Yup.string().when('archieve', {
      //     is: true,
      //     then: Yup.string().required('BackupDurationDays is Required')
      // })
     // BackupDurationDays: Yup.string().required('BackupDurationDays is REquired'),

    });

    const handleClientChange = (index) => (event) => {
      const selectedClientId = event.target.value;
      const selectedClient = clientDetails.find((client) => Number(client.ID) === Number(selectedClientId));
      const selectedTimezoneId = selectedClient?.TimezoneId ? String(selectedClient.TimezoneId) : '';

      setFormDataList((prevFormList) => {
        prevFormList[index].clientid = selectedClientId;
        prevFormList[index].locationid = '';

        if (!dialogData.id && selectedTimezoneId) {
          prevFormList[index].TimezoneId = selectedTimezoneId;
        }

        if (index === 0 && prevFormList.length > 1 && !dialogData.id) {
          for (let i = 1; i < prevFormList.length; i++) {
            prevFormList[i].clientid = selectedClientId;
            prevFormList[i].locationid = '';
            if (selectedTimezoneId) {
              prevFormList[i].TimezoneId = selectedTimezoneId;
            }
          }
        }
        return prevFormList
      })

      if (!selectedClientId) {
        setLocationOptionsByIndex((prev) => ({ ...prev, [index]: [] }));
      }

      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [`${index}.clientid`]: '',
        [`${index}.locationid`]: '',
        [`${index}.TimezoneId`]: ''
      }));
    };

    const handleLocationChange = (index) => (event) => {
      const selectedLocationId = event.target.value;
      setFormDataList((prevFormList) => {
        prevFormList[index].locationid = selectedLocationId;
        if (index === 0 && prevFormList.length > 1 && !dialogData.id) {
          for (let i = 1; i < prevFormList.length; i++) {
            prevFormList[i].locationid = selectedLocationId;
          }
        }
        return prevFormList;
      });

      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [`${index}.locationid`]: ''
      }));
    };

    const handleServerChange = (event, index) => {
      const newServerId = event.target.value;
      const selectedServer = serverDetails.find(server => server.Id === newServerId);
      
      console.log('Server Details',serverDetails)
      
      if (formDataList[index].server_id !== newServerId) {
        setOriginalServerId(formDataList[index].server_id);
      }
      // setSelectedserverId(newServerId);
      setFormDataList((prevFormData) => {
        prevFormData[index].server_id = event.target.value
        return prevFormData
      })

      if (selectedServer) {
        const existingCount = selectedServer.devices_count
        const count = formDataList.filter(item => item.server_id === newServerId).length;
        const newCount = existingCount + count + 1;
        const capacity = selectedServer.CameraCapacity

        if (newCount > capacity && capacity > 0) {
          console.log(dialogData)
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            [`${index}.server_id`]: `Cannot add more devices. Camera capacity (${selectedServer.CameraCapacity}) exceeded.`
          })); 
          return;
        
        } 
      }

      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [`${index}.server_id`]: '' // Clear error message for the current index
      }));
    
    };


    // const handleServerChange = (event, index) => {
    //   const selectedServer = serverDetails.find(server => server.Id === event.target.value);
    
    //   if (selectedServer.CameraCapacity === selectedServer.devices_count) {
    //     setErrorMessage("Server camera capacity reached. Please select another server or remove a camera to assign the current camera.");
    //     return;
    //   } else {
    //     setErrorMessage(""); // Clear error if valid
    //   }
    
    //   // Update form data state
    //   setFormData(prevState => ({
    //     ...prevState,
    //     server_id: event.target.value
    //   }));
    
    //   // Clear previous errors
    //   setFormErrors(prevErrors => ({
    //     ...prevErrors,
    //     [`${index}.server_id`]: ""
    //   }));
    // };


    const handleTimeChange = (event, index) => {
      // setSelectedtimezoneID(newTimeId);
      let value = event.target.value
      if (formDataList[index].TimezoneId !== value) {
        setOriginalTimeZone(formDataList[index].TimezoneId);
      }

      setFormDataList((prevFormData) => {
        prevFormData[index].TimezoneId = event.target.value
        return prevFormData
      })
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [`${index}.TimezoneId`]: '' // Clear error message for the current index
      }));
    };
    

    const handleAddCamera = () => {
      // console.log("client ID", selectedClientId)
      const selectedServerId = formDataList[0].server_id;
      const selectedServer = serverDetails.find(server => server.Id === selectedServerId);
      console.log(formDataList)
      const index = formDataList.length;
      if (selectedServer) {
        // if (selectedServer.devices_count >= selectedServer.CameraCapacity && selectedServer.CameraCapacity && selectedServer.devices_count>0) {
        //   setFormErrors((prevErrors) => ({
        //     ...prevErrors,
        //     [`${index}.server_id`]: `Cannot add more devices. Camera capacity (${selectedServer.CameraCapacity}) exceeded.`
        //   }));
        // } 
        const capacity = selectedServer.CameraCapacity
        const existingCount = selectedServer.devices_count
        const count = formDataList.filter(item => item.server_id === selectedServerId).length;

        const newCount = existingCount + count + 1;

        if(newCount > capacity && capacity > 0){
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            [`${index}.server_id`]: `Cannot add more devices. Camera capacity (${selectedServer.CameraCapacity}) exceeded.`
          }));
        }
      }

      console.log(formDataList)
      setFormDataList([
        ...formDataList,
        {
          clientid: formDataList.length > 0 ? formDataList[0].clientid : null,
          locationid: formDataList.length > 0 ? formDataList[0].locationid : '',
          CameraView: '',
          Serverport: '', 
          server_id: formDataList.length > 0 ? formDataList[0].server_id : '',
          MainStream: '',
          TimezoneId: formDataList.length > 0 ? formDataList[0].TimezoneId : null,
          Category: formDataList.length > 0 ? formDataList[0].Category : '2',
          substream: '',
          ReStream: '',
          LocalDeviceName: '',
          devicename:'',
          fps: formDataList.length > 0 ? formDataList[0].fps : null, 
          IsActive: formDataList.length > 0 ? formDataList[0].IsActive :0,
          CameraMake: '',
          CameraModel: '',
          LocalHTTPURL: '',
          PublicHTTPURL: '',
          HaveSpeaker: 0,
          BackupDurationDays:formDataList.length > 0 && formDataList[0].IsActive!==0  ? formDataList[0].BackupDurationDays : '',
          Footage:formDataList.length > 0 ? formDataList[0].Footage:'',
          IsAgentBased:formDataList.length > 0 ? formDataList[0].IsAgentBased:'',
          EventsBackupDays:formDataList.length > 0 ? formDataList[0].EventsBackupDays : '',
          EscalatedEventsBackupDays : formDataList.length > 0 ? formDataList[0].EscalatedEventsBackupDays : '',
          // BeforeVideo: 0,
          // AfterVideo: 0,
          BeforeVideo: formDataList.length > 0 ? formDataList[0].BeforeVideo : 0,
          AfterVideo: formDataList.length > 0 ? formDataList[0].AfterVideo : 0,
          MonitoringStartDate: formDataList.length > 0 ? formDataList[0].MonitoringStartDate : '', 
          MonitoringEndDate: formDataList.length > 0 ? formDataList[0].MonitoringEndDate : '',
        }
      ]);
    };
    const handleRemoveCamera = () => {
      if (formDataList.length === 1) {

        return;
      }
      
      setFormDataList(prevFormDataList => {
          const newList = [...prevFormDataList];
          newList.pop(); 
          return newList;
      });
  };
  
  
    
  
    const handleChange = (index) => (field) => (event) => {
      const { value } = event.target;
      
      const isNumberField = ['Serverport', 'fps', 'BackupDurationDays', 'EventsBackupDays', 'EscalatedEventsBackupDays', 'BeforeVideo', 'AfterVideo'].includes(field);
      const newValue = isNumberField ? (value === '' ? null : parseInt(value, 10)) : value;

      const newList = formDataList.map((formData, i) => {
        if (i === index) {
          return { ...formData, [field]: newValue };
        }
        return formData;
      });
  
      if (field === "clientid") {
        const updatedFormDataList = newList.map(formData => {
          return { ...formData, clientid: formDataList[0].clientid }
        });
        setFormDataList(updatedFormDataList);
      } else {
        // Otherwise, update the form data list with changes for the specific form
        setFormDataList(newList);
      }
       let errorMessage='';

       // Check if the field is "BackupDurationDays"
       if (field === 'BackupDurationDays') {
        if (value === '' || value === null) {
          setFormErrors(prevErrors => ({
            ...prevErrors,
            [`${index}.BackupDurationDays`]: 'Backup Duration Days is required'
          }));
        } else if (!isNaN(value)) {
          const intValue = parseInt(value, 10);
          if (intValue < 1 || intValue > 30) {
            setFormErrors(prevErrors => ({
              ...prevErrors,
              [`${index}.BackupDurationDays`]: 'Backup Duration Days must be between 1 and 30'
            }));
          } else {
            // Clear error if valid
            setFormErrors(prevErrors => ({
              ...prevErrors,
              [`${index}.BackupDurationDays`]: ''
            }));
          }
        }
      }
      else {
        // Clear error message for other fields
        setFormErrors(prevErrors => ({
          ...prevErrors,
          [`${index}.${field}`]: ''
        }));
      }
    };
  
  
    
      
    // const handleSwitchChange = (index) => (name) => (event) => {
    //   const value = event.target.checked ? 1 : 0;
    //   setFormDataList((prevFormDataList) => {
    //     const updatedFormDataList = [...prevFormDataList];
    //     updatedFormDataList[index] = {
    //       ...updatedFormDataList[index],
    //       [name]: value
    //     };
    //     return updatedFormDataList;
    //   });
      
    // };  
    // handling for before submitting save that range function
    const handleSwitchChange = (index) => (name) => (event) => {
      
      const value = event.target.checked ? 1 : 0;
      setFormDataList((prevFormDataList) => {
        const updatedFormDataList = [...prevFormDataList];
        updatedFormDataList[index] = {
          ...updatedFormDataList[index],
          [name]: value
        };
    
        // If "Is Need Archive" switch is toggled, and Backup Duration Days is not provided,
        // set an error message
        if (name === 'IsActive' && value === 1 && !updatedFormDataList[index].BackupDurationDays) {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            [`${index}.BackupDurationDays`]: 'Backup Duration Days is required'
          }));
        } else {
          // Clear the error message if Backup Duration Days is provided or "Is Need Archive" is toggled off
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            [`${index}.BackupDurationDays`]: ''
          }));
        }
    
        return updatedFormDataList;
      });
    };
    
        
    const jsonToFormData = (data) => {
      let formdata = new FormData()
      for (let x in data)
        formdata.append(x, data[x])
      return formdata
    }
  
    const handleSubmit = () =>  {     

      setIsSubmitting(true)
      setErrorMessage('');
      const ServerError = Object.keys(formErrors).some(key => key.endsWith('.server_id') && formErrors[key] !== '');
      if(ServerError){
        setIsSubmitting(false)
        return;
      }
      let count = 0;  
      Promise.all(
        formDataList.map((formData, index) => {
          
          setSaveClicked(true);
          const customErrors = [];
          if (hasLocationsForIndex(index) && !String(formData.locationid || '').trim()) {
            count = 1;
            customErrors.push({
              path: `${index}.locationid`,
              message: 'Location is required'
            });
          }
         
          if (formData.IsActive && !formData.BackupDurationDays) {
              count = 1;
              return customErrors; // Do not save if BackupDurationDays is not entered
          }
          if (formData.IsActive && formData.BackupDurationDays === 0) {
            count = 1;
            return customErrors; // Do not save if BackupDurationDays is not entered
        }
          
          return schema.validate(formData, { abortEarly: false })
            .then(() => customErrors)
            .catch(errors => {

              // console.log("errors test",errors);
              return [
                ...customErrors,
                ...errors.inner.map(error => (
                count = 1,
                {
                ...error,
                path: `${index}.${error.path}`,
                
               
               
              }))
            ];
            });
            
        })
      )
      .then((validationResults) => {

        const allErrors = validationResults.flat()
          .filter(error => !!error); // Filter out any null or undefined values
        
        const errorCount = count;
        // console.log("Number of errors:", count);    

        if (dialogData && dialogData.id) {
         
          if (errorCount === 0){
            
                    // console.log('test',dialogData,dialogData.id.deviceid)
                    // if(dialogData.id.devicename == ''){
                    //   setCameraError("Camera Name is required")
                    // }
                    // const formDataList1 = {...formDataList[0], deviceid: dialogData.id.deviceid };   
                    // console.log("Before update BCDD", formDataList1);
                    const updatedFields = {};
                   
                    console.log(formDataList,originalFormDataList)
                    let days = 0;
                    // Compare current form data with original data
                    formDataList.forEach((formData, index) => {
                   
                      const originalData = originalFormDataList[index] || {};
                      Object.keys(formData).forEach(key => {
                        //var x=originalData['BackupDurationDays']
                        
                        if(key === "BackupDurationDays"){
                          days = originalData['BackupDurationDays'];
                        }
                        
                        if (formData[key] !== originalData[key]) {
                          updatedFields[key] = formData[key];
                        }
                      });

                      const cameraConfigurationChanged = CAMERA_CONFIGURATION_FIELDS.some(
                        (field) => formData[field] !== originalData[field]
                      );

                      if (cameraConfigurationChanged) {
                        CAMERA_CONFIGURATION_FIELDS.forEach((field) => {
                          updatedFields[field] = formData[field] ?? '';
                        });
                      }
                      
                      if (formData.BackupDurationDays !== undefined && formData.BackupDurationDays !== days && days) {
                        updatedFields.IsActive = formData.IsActive;
                      }
                      if (formData.server_id !== originalServerId || (!originalServerId && formData.server_id !== null)) {
                        updatedFields.server_id = formData.server_id;
                      }
                      //if (formData.IsAgentBased !== originalEventSendTo && originalEventSendTo) {
                        if (formData.IsAgentBased !== undefined && formData.IsAgentBased!=="") {
                        updatedFields.IsAgentBased = formData.IsAgentBased;
                      }
                      if (formData.TimezoneId !== originalTimeZone && originalTimeZone) {
                        updatedFields.TimezoneId = formData.TimezoneId;
                      }

                      if('Category' in updatedFields && !('IsAgentBased' in updatedFields)){
                        updatedFields.IsAgentBased = formData.IsAgentBased;
                      }

                    });

                    updatedFields.deviceid = dialogData.id.deviceid;
                    updatedFields.clientid = formDataList[0]?.locationid || dialogData.id.clientid;
                    if (formDataList[0]?.locationid) {
                      updatedFields.Locations = Number(formDataList[0].locationid);
                    }
                  

                    putExistingDevice(async (response) => {
                      if (response.status === 200 || response.status === 201) {
                        const isReloaded = await handleReloadPage();
                        setIsSubmitting(false)
                        onClose();
                      }
                    }, jsonToFormData(updatedFields))


                    // const API_ENDPOINT = 'http://14.97.205.250:9002/devices/update';
                    // try {
                    //   const formDataList1 = {...formDataList[0], deviceid: dialogData.id.deviceid };   
                    //   console.log("update", formDataList1);
                    //   axios.put(API_ENDPOINT, jsonToFormData(formDataList1), {
                    //     headers: {
                    //       'accept': 'application/json',
                    //       'Content-Type': 'application/x-www-form-urlencoded'
                    //       // Authorization: AUTH_TOKEN
                    //     }
                    //   })
                    //   .then(response => {
                    //     console.log('API Response:', response.data);
                    //     onClose();


                    //   })
                    //   .catch(error => {
                    //     console.error('API Error:', error);
                        
                    //   });
                    // } catch (error) {
                    //   console.error('Error:', error);
                    // }                       
                  }
                  else{
                    setIsSubmitting(false)
                    const fieldErrors = {};
                    allErrors.forEach((error) => {
                      // Ensure that error.path is not undefined or null before splitting it
                      const [formIndex, fieldName] = (error.path ?? '').split('.');
                      // Creating a new error path with the index included
                      const indexedFieldName = `${formIndex}.${fieldName}`;
                      fieldErrors[indexedFieldName] = error.message;
                    });
                
                    setFormErrors(fieldErrors);

                  }
           
                  }
        else {

                  if (errorCount === 0) {
                    setFormErrors({});
                    // console.log("actual Form Errors",formErrors)
                
                    console.log(formDataList)
                    const formattedFormData = formDataList.map(({ locationid, ...formData }) => ({
                      ...formData,
                      clientid: (locationid || formData.clientid).toString(),
                      ...(locationid ? { Locations: String(locationid) } : {}),
                      // server_id :selectedServerId !== '' ? parseInt(selectedServerId, 10): null,
                      Serverport: formData.Serverport !== '' ? parseInt(formData.Serverport, 10) : null,
                      fps: formData.fps !== '' ? parseInt(formData.fps, 10) : null,
                      Category : formData.Category === '' ? '0': formData.Category || '0',
                      BackupDurationDays: formData.BackupDurationDays !== '' ? parseInt(formData.BackupDurationDays, 10) : null
                    }));

                    const formsWithLocation = formDataList.filter((item) => item.locationid);
                    const doCreateCamera = () => {
                      setNewDevice((response) => {
                        if (response.status === 200 || response.status === 201) {
                          // console.log(response.data);
                          handleReloadPage();
                          onClose();
                        } else {
                          setIsSubmitting(false);
                        }
                      }, formattedFormData);
                    };

                    if (formsWithLocation.length > 0) {
                      const relatedClientIds = [...new Set(
                        formsWithLocation.flatMap((item) =>
                          getRelatedClientIds(item.clientid).filter((id) => !Number.isNaN(id))
                        )
                      )];

                      getCamerasList((cameraResponse) => {
                        if (cameraResponse.status === 200) {
                          const existingCameras = cameraResponse.data || [];
                          const hasOlderCamerasWithoutLocation = existingCameras.some((cam) => {
                            const cameraClientId = Number(cam.clientid || cam.client_id || 0);
                            const cameraLocation = String(cam.Location ?? '').trim();
                            return relatedClientIds.includes(cameraClientId) && cameraLocation === '';
                          });

                          if (hasOlderCamerasWithoutLocation) {
                            setIsSubmitting(false);
                            setErrorMessage('Before adding a location to a new camera, please assign locations to existing cameras. Only after updating existing cameras can you add locations to new cameras.');
                            return;
                          }
                        }

                        doCreateCamera();
                      });
                    } else {
                      doCreateCamera();
                    }
                
                    // console.log("Formatted Form Data:", formattedFormData);
                
                    // const apiUrl = 'http://14.97.205.250:9002/devices/add';
                    // const AUTH_TOKEN = `${localStorage.getItem('token_type')} ${localStorage.getItem('access_token')}`;
                
                    // axios.post(apiUrl, formattedFormData, {
                    //   headers: {
                    //     Authorization: AUTH_TOKEN
                    //   }
                    // })
                    // .then(response => {
                    //   if (response.status === 200 || response.status === 201) {
                    //     console.log(response.data);
                    //     onClose();
                    //     // setSelectedClientId('');
                    //   }
                    // })
                    // .catch(error => {
                    //   console.error('Error:', error.message);
                    // });

                  } else {
                    setIsSubmitting(false)
                    // Set errors if validation failed
                    const fieldErrors = {};
                    allErrors.forEach((error) => {
                      // Ensure that error.path is not undefined or null before splitting it
                      const [formIndex, fieldName] = (error.path ?? '').split('.');
                      // Creating a new error path with the index included
                      const indexedFieldName = `${formIndex}.${fieldName}`;
                      fieldErrors[indexedFieldName] = error.message;
                    });
                
                    setFormErrors(fieldErrors);
                  }
          }
      })
      .catch((error) => {
        console.error('Error:', error.message);
      });
      
    };  

    // const onClose = () => {
    //   setOpen(false);
    //   setSaveClicked(false);
    //   setFormDataList([ 
    //     {
    //       clientid: '',
    //       CameraView: '',
    //       Serverport: null, 
    //       MainStream: '',
    //       substream: '',
    //       Category:'',
    //       ReStream: '',
    //       LocalDeviceName: '',
    //       devicename: '',
    //       server_id: '',
    //       fps: null, 
    //       IsActive: 0,
    //       CameraMake: '',
    //       CameraModel: '',
    //       LocalHTTPURL: '',
    //       PublicHTTPURL: '',
    //       HaveSpeaker: 0,
    //       TimezoneId:'',
    //       BackupDurationDays: null,
    //       Footage:'',
    //       IsAgentBased:''
    //     }
    //   ]);
    //   setFormErrors({});
    //   setSelectedFootage(Array(formDataList.length).fill(''));
    //   setSelectedEventsType(Array(formDataList.length).fill(''));

    //   setOriginalFormDataList([]);
    //   setOriginalServerId('')
    //   setOriginalEventSendTo('')
    //   setOriginalTimeZone('')
    // }

    const onClose = () => {
          setOpen(false);
          setSaveClicked(false);
          setFormDataList([{
            clientid: '',
            locationid: '',
            CameraView: '',
            server_id: '',
            Serverport: '', 
            TimezoneId: '',
            MainStream: '',
            Category: '2',
            substream: '',
            ReStream: '',
            LocalDeviceName: '',
            devicename: '',
            fps: null, 
            IsActive: 0,
            CameraMake: '',
            CameraModel: '',
            LocalHTTPURL: '',
            PublicHTTPURL: '',
            HaveSpeaker: 0,
            BeforeVideo: 0,
            AfterVideo: 0,
            BackupDurationDays: '',
            Footage: '',
            IsAgentBased: '',
            EventsBackupDays: '',
            EscalatedEventsBackupDays: '',
            MonitoringStartDate: '', 
            MonitoringEndDate: '',
          }]);
          setFormErrors({});
          setSelectedFootage([]);
          setSelectedEventsType([]);
          setOriginalFormDataList([]);
          setOriginalServerId('');
          setOriginalEventSendTo('');
          setOriginalTimeZone('');
          setLocationOptionsByIndex({});
          setErrorMessage('');
    };


    // useEffect(() => {
    //   // console.log("clients from Device form");
    //   getClientList((response) => {
    //     if (response.status === 200) {
          

    //       const filteredData = response.data.filter(item => item.ClientType !== null);

    //       const sortedData = [...filteredData].sort((a,b)=>
    //         a.displayname.trim().localeCompare(b.displayname.trim())
    //       )
    //       setClient(sortedData)    
    //     }
    //   });
    // }, []);

    // useEffect(() => {
    //   // console.log("Server ");
    //   getServerList((response) => {
    //     if (response.status === 200) {
    //       // console.log("servers ", response.data);
    //       setServer(response.data)    
    //     }
    //   });
    // }, []);
    
    // useEffect(() => {
    //   // console.log("Server ");
    //   getTimezoneList((response) => {
    //     if (response.status === 200) {
    //       // console.log("Time Zone ", response.data);
    //       setTimezone(response.data)    
    //     }
    //   });
    // }, []);

    useEffect(() => {
      const loadData = async () => {
        setIsLoading(true);
        try {
          await Promise.all([
            client.getClients((response) => {
              if (response.status === 200) {
                const normalizedClients = (response.data || []).map((item) => ({
                  ...item,
                  Location: item.hasOwnProperty('Location') ? item.Location : '',
                  AssignClient: item.hasOwnProperty('AssignClient') ? item.AssignClient : 0
                }));
                const filteredData = normalizedClients.filter(item => item.ClientType !== null);
                const sortedData = [...filteredData].sort((a,b) => 
                  a.displayname.trim().localeCompare(b.displayname.trim())
                );
                setClient(sortedData);
                setUniqueClientOptions(buildUniqueClientOptions(sortedData));
              }
            }),
            getServerList((response) => {
              if (response.status === 200) {
                setServer(response.data);
              }
            }),
            getTimezoneList((response) => {
              if (response.status === 200) {
                setTimezone(response.data);
              }
            })
          ]);
        } finally {
          setIsLoading(false);
        }
      };
      loadData();
    }, []);



    // useEffect(() => {
      
    //   if(dialogData){     
    //     const keys = ['clientid','CameraView','TimezoneId','devicename','Category','Serverport','MainStream','substream','ReStream','LocalDeviceName','server_id','fps','IsActive','BackupDurationDays','CameraMake','CameraModel','LocalHTTPURL','PublicHTTPURL','HaveSpeaker','Footage','IsAgentBased','EscalatedEventsBackupDays','EventsBackupDays','BeforeVideo','AfterVideo'];
    //     const values = ['clientid','CameraView','TimezoneId','devicename','Category','Serverport','MainStream','substream','ReStream','LocalDeviceName','server_id','fps','IsActive','BackupDurationDays','CameraMake','CameraModel','LocalHTTPURL','PublicHTTPURL','HaveSpeaker','Footage','IsAgentBased','EscalatedEventsBackupDays','EventsBackupDays','BeforeVideo','AfterVideo'];
        
        
    //     if (dialogData.id) {
    //       const updatedFormDataList = formDataList.map((formData) => {
    //         const updatedFormData = { ...formData };
    //         keys.forEach((key, idx) => {
            
    //           // console.log('index',dialogData.id[values[idx]]);
    //             updatedFormData[key] = dialogData.id[values[idx]] === null ? '' : dialogData.id[values[idx]];
              
             
    //         });
    //         return updatedFormData;
    //       });
    //       // console.log("updatd ",updatedFormDataList)
    //       setFormDataList([...updatedFormDataList]);
    //       setOriginalFormDataList([...updatedFormDataList]);
    //     } 
        
        
    //     else {
    //     //  setOpen({...dialogData, isOpen: true, id: null})
    //     }
    //   }
    // }, [dialogData]);    

    useEffect(() => {
      if (dialogData && dialogData.isOpen && !isLoading) {
        const keys = ['clientid', 'CameraView', 'TimezoneId', 'devicename', 'Category', 'Serverport', 'MainStream', 'substream', 'ReStream', 'LocalDeviceName', 'server_id', 'fps', 'IsActive', 'BackupDurationDays', 'CameraMake', 'CameraModel', 'LocalHTTPURL', 'PublicHTTPURL', 'HaveSpeaker', 'Footage', 'IsAgentBased', 'EscalatedEventsBackupDays', 'EventsBackupDays', 'BeforeVideo', 'AfterVideo', 'MonitoringStartDate','MonitoringEndDate'];
        const values = ['clientid', 'CameraView', 'TimezoneId', 'devicename', 'Category', 'Serverport', 'MainStream', 'substream', 'ReStream', 'LocalDeviceName', 'server_id', 'fps', 'IsActive', 'BackupDurationDays', 'CameraMake', 'CameraModel', 'LocalHTTPURL', 'PublicHTTPURL', 'HaveSpeaker', 'Footage', 'IsAgentBased', 'EscalatedEventsBackupDays', 'EventsBackupDays', 'BeforeVideo', 'AfterVideo','MonitoringStartDate','MonitoringEndDate'];
        
        if (dialogData.id) {
          const updatedFormDataList = formDataList.map((formData) => {
            const updatedFormData = { ...formData };
            keys.forEach((key, idx) => {
              updatedFormData[key] = dialogData.id[values[idx]] === null ? '' : dialogData.id[values[idx]];
            });
            updatedFormData.locationid = dialogData.id.clientid || '';
            return updatedFormData;
          });
          
          setFormDataList([...updatedFormDataList]);
          setOriginalFormDataList([...updatedFormDataList]);
          setOriginalServerId(dialogData.id.server_id || '');
          setOriginalEventSendTo(dialogData.id.IsAgentBased || '');
          setOriginalTimeZone(dialogData.id.TimezoneId || '');
        } else {
          setFormDataList([{
            clientid: '',
            locationid: '',
            CameraView: '',
            server_id: '',
            Serverport: '', 
            TimezoneId: '',
            MainStream: '',
            Category: '2',
            substream: '',
            ReStream: '',
            LocalDeviceName: '',
            devicename: '',
            fps: 8, 
            IsActive: 1,
            CameraMake: '',
            CameraModel: '',
            LocalHTTPURL: '',
            PublicHTTPURL: '',
            HaveSpeaker: 0,
            BeforeVideo: 10,
            AfterVideo: 60,
            BackupDurationDays: 15,
            Footage: 1,
            IsAgentBased: 1,
            EventsBackupDays: 15,
            EscalatedEventsBackupDays: 90
          }]);
          setOriginalFormDataList([]);
          setOriginalServerId('');
          setOriginalEventSendTo('');
          setOriginalTimeZone('');
        }
      }
    }, [dialogData, isLoading]);

    useEffect(() => {
      if (!dialogData?.isOpen || isLoading || clientDetails.length === 0) return;

      formDataList.forEach((formData, index) => {
        const clientId = formData.clientid;
        if (!clientId) {
          setLocationOptionsByIndex((prev) => ({ ...prev, [index]: [] }));
          return;
        }

        fetchLocationsForClient(clientId, index);
      });
    }, [dialogData?.isOpen, isLoading, clientDetails, formDataList.map((item) => item.clientid).join(',')]);


    const [selectedFootage, setSelectedFootage] = useState(Array(formDataList.length).fill(''));
    const [selectedEventsType, setSelectedEventsType] = useState(Array(formDataList.length).fill(''));

    const handleFootageChange = (index) => (event) => {
     
      console.log(formErrors)
      const value = event.target.value;
      setSelectedFootage(prevSelectedFootage => {
        const newSelectedFootage = [...prevSelectedFootage];
        newSelectedFootage[index] = value;
        return newSelectedFootage;
      });

      setFormDataList((prevFormList) => {
        prevFormList[index].Footage = event.target.value
        return prevFormList
      })

      if(value){
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [`${index}.Footage`]: '' 
        }));
  
      }
    };
    
    const handleEventsTypeChange = (index) => (event) => {
      const value = event.target.value;
      if (formDataList[index].IsAgentBased !== value) {
        setOriginalEventSendTo(formDataList[index].IsAgentBased);
      }
      setSelectedEventsType(prevSelectedEventsType => {
        const newSelectedEventsType = [...prevSelectedEventsType];
        newSelectedEventsType[index] = value;
        return newSelectedEventsType;
      });

      setFormDataList((prevFormList) => {
        prevFormList[index].IsAgentBased = event.target.value
        return prevFormList
      })

      if(value){
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [`${index}.IsAgentBased`]: '' 
        }));
      }

    };
    return (
    <Dialog fullWidth={fullWidth}  maxWidth="xl" open={dialogData.isOpen}  >
          <DialogTitle>Add/Edit Camera</DialogTitle>

        {dialogData.id ? null : (
          <>
            <LoadingButton
              onClick={handleRemoveCamera}
              color="error"
              variant="outlined"
              startIcon={<Iconify icon="eva:minus-fill" />}
              style={{
                position: "absolute",
                top: "20px",
                right: "90px",
              }}
            > </LoadingButton>

             <LoadingButton
              onClick={handleAddCamera}
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
              }}
            > {formDataList.length}</LoadingButton>
          </>
        )}

        <Grid container spacing={2}>
          <Grid item md={8}></Grid>
        </Grid>
        <DialogContent sx={{ "& .MuiFormLabel-asterisk": { color: "error.main" } }}>
          {errorMessage ? (
            <Alert severity="warning" sx={{ mb: 2 }}>
              {errorMessage}
            </Alert>
          ) : null}
          {formDataList.map((formData, index) => {
            return (
            <Card key={`form-card-${index}-${dialogData.id?.deviceid || 'new'}`} sx={{padding:'6px',mb: 2}}>
              <Typography
                variant="subtitle2"
                sx={{
                  my: 2, // margin top and bottom
                  padding: "8px", // optional padding
                  borderRadius: "4px", 
                }}
              >
                Basic Info 
              </Typography>
              <Grid container spacing={2}>

                <Grid item md={2}>
                  <FormControl fullWidth error={!!formErrors[`${index}.clientid`]}>
                    <Autocomplete
                      id={`clientid-${index}`}
                      options={uniqueClientOptions}
                      getOptionLabel={(option) =>
                        `${option.displayname || ""}`
                      }
                      isOptionEqualToValue={(option, value) => option.ID === value.ID}
                      value={
                        (() => {
                          const selectedClient = clientDetails.find((client) => Number(client.ID) === Number(formData.clientid));
                          if (!selectedClient) return null;
                          return uniqueClientOptions.find(
                            (client) => normalizeDisplayName(client.displayname) === normalizeDisplayName(selectedClient.displayname)
                          ) || null;
                        })()
                      }
                      onChange={(event, newValue) => {
                        handleClientChange(index)({
                          target: { value: newValue ? newValue.ID : "" },
                        });

                        if (newValue) {
                          setFormDataList((prevFormList) => {
                            const updatedList = [...prevFormList];

                            updatedList[index] = {
                              ...updatedList[index],
                              MonitoringStartDate: newValue.MonitoringStartDate || "",
                              MonitoringEndDate: newValue.MonitoringEndDate || "",
                            };

                            if (index === 0 && formDataList.length > 1 && !dialogData.id) {
                              for (let i = 1; i < updatedList.length; i++) {
                                updatedList[i] = {
                                  ...updatedList[i],
                                  MonitoringStartDate: newValue.MonitoringStartDate || "",
                                  MonitoringEndDate: newValue.MonitoringEndDate || "",
                                };
                              }
                            }

                            return updatedList;
                          });
                        }
                      }}
                      filterOptions={(options, { inputValue }) =>
                        options.filter((option) =>
                          option.displayname.toLowerCase().includes(inputValue.toLowerCase())
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Client Name"
                          required
                          InputLabelProps={{ shrink: true }}
                          error={!!formErrors[`${index}.clientid`]}
                          variant="outlined"
                        />
                      )}
                      disabled={!!dialogData.id}
                    />

                    <FormHelperText>
                      {formErrors[`${index}.clientid`] || ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>              
                
	                {hasLocationsForIndex(index) && (
	                <Grid item md={2}>
	                  <FormControl fullWidth required error={!!formErrors[`${index}.locationid`]}>
	                    <InputLabel
	                      id={`location-label-${index}`}
	                      required
	                      shrink
	                      sx={{ backgroundColor: 'background.paper', px: 0.5 }}
	                    >
	                      Location
	                    </InputLabel>
	                    <Select
	                      labelId={`location-label-${index}`}
	                      id={`location-${index}`}
	                      value={formData.locationid || ''}
	                      label="Location"
	                      onChange={handleLocationChange(index)}
	                      disabled={!formData.clientid}
	                    >
	                      {(locationOptionsByIndex[index] || []).map((loc) => {
	                        const locId = loc.ID || loc.id;
	                        const locName = loc.Location || loc.name || '';
	                        return (
	                          <MenuItem key={`location-option-${index}-${locId}`} value={locId}>
	                            {locName}
	                          </MenuItem>
	                        );
	                      })}
	                    </Select>
	                    <FormHelperText>
	                      {formErrors[`${index}.locationid`] || ""}
	                    </FormHelperText>
	                  </FormControl>
	                </Grid>
	                )}
                <Grid item md={2}>
                  <FormControl fullWidth>
                    <InputLabel
                      id="camera-view-label"
                      shrink
                      sx={{ backgroundColor: 'background.paper', px: 0.5 }}
                    >
                      Camera View
                    </InputLabel>
                    <Select
                      label="Camera View"
                      labelId="camera-view-label"
                      id="camera-view"
                      value={formData.CameraView}
                      onChange={handleChange(index)("CameraView")} // Pass the index here
                      // error={!!formErrors[`${index}.CameraView`]}
                    >
                      <MenuItem value="In Door">In Door</MenuItem>
                      <MenuItem value="Out Door">Out Door</MenuItem>
                    </Select>
                    {/* <FormHelperText style={{ color: "red" }}>
                      {formErrors[`${index}.CameraView`] || ""}
                    </FormHelperText> */}
                  </FormControl>
                </Grid>
                <Grid item md={2}>
                  <FormControl fullWidth error={!!formErrors[`${index}.Category`]}>
                    <InputLabel id="camera-Cat-label">Category</InputLabel>
                    <Select
                      label="Category"
                      labelId="camera-cat-label"
                      id="camera-cat"
                      value={formData.Category || 0}
                      onChange={handleChange(index)("Category")}
                      error={!!formErrors[`${index}.Category`]}
                    >
                      <MenuItem value="0">Not Assigned</MenuItem>
                      <MenuItem value="1"> Category 1</MenuItem>
                      <MenuItem value="2"> Category 2</MenuItem>
                      <MenuItem value="3"> Category 3</MenuItem>
                    </Select>
                    <FormHelperText>
                      {formErrors[`${index}.Category`] || ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item md={2}>
                  <FormControl fullWidth required error={!!formErrors[`${index}.TimezoneId`]}>
                    <InputLabel id="timeZone-label" shrink>
                      Time Zone
                    </InputLabel>

                    <Select
                      label="Time Zone"
                      labelId="timeZone-label"
                      id="timeZone"
                      value={formData.TimezoneId}
                      onChange={(event) => handleTimeChange(event, index)}
                      error={!!formErrors[`${index}.TimezoneId`]}
                      displayEmpty
                    >
                      {timezoneDetails.map((option) => (
                        <MenuItem key={option.Id} value={option.Id}>
                          {option.TimeZone}
                        </MenuItem>
                      ))}
                    </Select>

                    <FormHelperText>
                      {formErrors[`${index}.TimezoneId`] || ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="Camera Name"
                    required
                    InputLabelProps={{ shrink: true }}
                    value={formData.devicename}
                    onChange={handleChange(index)("devicename")}
                    error={!!formErrors[`${index}.devicename`]}
                    helperText={formErrors[`${index}.devicename`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="Server Port"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    value={formData.Serverport}
                    onChange={handleChange(index)("Serverport")}
                    // error={!!formErrors[`${index}.Serverport`]}
                    // helperText={formErrors[`${index}.Serverport`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="Main Stream"
                    InputLabelProps={{ shrink: true }}
                    value={formData.MainStream}
                    onChange={handleChange(index)("MainStream")}
                    // error={!!formErrors[`${index}.MainStream`]}
                    // helperText={formErrors[`${index}.MainStream`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="Sub Stream"
                    required
                    InputLabelProps={{ shrink: true }}
                    value={formData.substream}
                    onChange={handleChange(index)("substream")}
                    error={!!formErrors[`${index}.substream`]}
                    helperText={formErrors[`${index}.substream`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="ReStream"
                    InputLabelProps={{ shrink: true }}
                    value={formData.ReStream}
                    onChange={handleChange(index)("ReStream")}
                    // error={!!formErrors[`${index}.ReStream`]}
                    // helperText={formErrors[`${index}.ReStream`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <FormControl fullWidth required error={!!formErrors[`${index}.server_id`]}>
                    <InputLabel id="server_id-label" shrink>
                      Server
                    </InputLabel>

                    <Select
                      label="Server"
                      labelId="server_id-label"
                      id="server_id"
                      value={formData.server_id}
                      onChange={(event) => handleServerChange(event, index)}
                      displayEmpty
                    >
                      {serverDetails.map((option) => (
                        <MenuItem key={option.Id} value={option.Id}>
                          {option.ServerName}
                        </MenuItem>
                      ))}
                    </Select>

                    <FormHelperText>
                      {formErrors[`${index}.server_id`] || ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="Frames Per Second (fps)"
                    type="number"
                    value={formData.fps || 8}
                    onChange={handleChange(index)("fps")}
                    // error={!!formErrors[`${index}.fps`]}
                    // helperText={formErrors[`${index}.fps`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <FormControl fullWidth required error={!!formErrors[`${index}.Footage`]}>
                    <InputLabel id="footage-label" shrink>
                      Footage
                    </InputLabel>

                    <Select
                      label="Footage"
                      labelId="footage-label"
                      id="footage"
                      value={formData.Footage || "1"}
                      onChange={handleFootageChange(index)}
                      displayEmpty
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="0">Image</MenuItem>
                      <MenuItem value="1">Video</MenuItem>
                    </Select>

                    <FormHelperText>
                      {formErrors[`${index}.Footage`] || ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item md={2}>
                  <FormControl fullWidth required error={!!formErrors[`${index}.IsAgentBased`]}>
                    <InputLabel id="events-type-label" shrink>
                      Event Send To
                    </InputLabel>

                    <Select
                      label="Event Send To"
                      labelId="events-type-label"
                      id="events-type"
                      //value={formData.IsAgentBased || "1"}
                      value={formData.IsAgentBased !== undefined && formData.IsAgentBased !== null && formData.IsAgentBased !== "" 
                            ? formData.IsAgentBased : "1"}
                      onChange={handleEventsTypeChange(index)}
                      displayEmpty
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="1">Tier 1</MenuItem>
                      <MenuItem value="0">Client</MenuItem>
                    </Select>

                    <FormHelperText>
                      {formErrors[`${index}.IsAgentBased`] || ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                 <Grid item md={2}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <FormControl fullWidth>
                          <DatePicker
                            label="Monitoring Start Date"
                            value={formData.MonitoringStartDate ? dayjs(formData.MonitoringStartDate) : null}
                            onChange={(newValue) => {
                              // Update the form data
                              const newList = formDataList.map((formDataItem, i) => {
                                if (i === index) {
                                  return { 
                                    ...formDataItem, 
                                    MonitoringStartDate: newValue ? newValue.format('YYYY-MM-DD') : '' 
                                  };
                                }
                                return formDataItem;
                              });
                              setFormDataList(newList);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                error={!!formErrors[`${index}.MonitoringStartDate`]}
                                helperText={formErrors[`${index}.MonitoringStartDate`] || ""}
                              />
                            )}
                            inputFormat="YYYY-MM-DD"
                            mask="____-__-__"
                            slotProps={{
                              textField: {
                                InputLabelProps: { shrink: true },
                              }
                            }}
                          />
                        </FormControl>
                      </LocalizationProvider>
                    </Grid>

                    <Grid item md={2}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <FormControl fullWidth>
                          <DatePicker
                            label="Monitoring End Date"
                            value={formData.MonitoringEndDate ? dayjs(formData.MonitoringEndDate) : null}
                            onChange={(newValue) => {
                              // Update the form data
                              const newList = formDataList.map((formDataItem, i) => {
                                if (i === index) {
                                  return { 
                                    ...formDataItem, 
                                    MonitoringEndDate: newValue ? newValue.format('YYYY-MM-DD') : '' 
                                  };
                                }
                                return formDataItem;
                              });
                              setFormDataList(newList);
                            }}
                            minDate={formData.MonitoringStartDate ? dayjs(formData.MonitoringStartDate) : null}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                error={!!formErrors[`${index}.MonitoringEndDate`]}
                                helperText={formErrors[`${index}.MonitoringEndDate`] || ""}
                              />
                            )}
                            inputFormat="YYYY-MM-DD"
                            mask="____-__-__"
                            slotProps={{
                              textField: {
                                InputLabelProps: { shrink: true },
                              }
                            }}
                          />
                        </FormControl>
                      </LocalizationProvider>
                    </Grid>


                <Grid item md={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="success"
                        checked={formData.IsActive === 1 ? true : false }
                        onChange={handleSwitchChange(index)("IsActive")}
                      />
                    }
                    label="Is Need Archives"
                  />
                </Grid>
                {formData.IsActive ? (
                    <Grid item md={2}>
                      <TextField
                        fullWidth
                        label="Archives Backup Days"
                        type="number"
                        required
                        InputLabelProps={{ shrink: true }}
                        value={formData.BackupDurationDays || 15}
                        onChange={handleChange(index)("BackupDurationDays")}
                        error={
                          saveClicked &&
                          formData.IsActive &&
                          (!formData.BackupDurationDays ||
                            formData.BackupDurationDays < 1 ||
                            formData.BackupDurationDays > 30)
                        }
                        helperText={
                          saveClicked &&
                          formData.IsActive &&
                          (!formData.BackupDurationDays ||
                            formData.BackupDurationDays < 1 ||
                            formData.BackupDurationDays > 30) &&
                          "Backup Duration Days must be between 1 and 30"
                        }
                        InputProps={{
                          inputProps: { min: 1, max: 30 },
                        }}
                      />
                    </Grid>
                  ) : null}

                  <Grid item md={2}>
                    <TextField
                      fullWidth
                      label="Events Backup Days"
                      type="number"
                      required
                      InputLabelProps={{ shrink: true }}
                      value={formData.EventsBackupDays || 15}
                      onChange={handleChange(index)("EventsBackupDays")}
                      error={!!formErrors[`${index}.EventsBackupDays`]}
                    />

                    <FormHelperText style={{ color: "red" }}>
                      {formErrors[`${index}.EventsBackupDays`] || ""}
                    </FormHelperText>
                  </Grid>

                  <Grid item md={2}>
                    <TextField
                      fullWidth
                      label="Escalated Events Backup Days"
                      type="number"
                      required
                      InputLabelProps={{ shrink: true }}
                      value={formData.EscalatedEventsBackupDays || 90}
                      onChange={handleChange(index)("EscalatedEventsBackupDays")}
                      error={!!formErrors[`${index}.EscalatedEventsBackupDays`]}
                    />

                    <FormHelperText style={{ color: "red" }}>
                      {formErrors[`${index}.EscalatedEventsBackupDays`] || ""}
                    </FormHelperText>
                  </Grid>
	                  <Grid item md={2}>
	                                    <TextField
	                                      fullWidth
	                                      label="Before Clip(Sec)"
	                                      type="number"
                                          required
                                          InputLabelProps={{ shrink: true }}
	                                      value={formData.BeforeVideo ?? ''}
	                                      onChange={handleChange(index)("BeforeVideo")}
	                                      error={!!formErrors[`${index}.BeforeVideo`]}
	                                      // helperText={formErrors[`${index}.fps`] || ""}
	                                    />
	                                    <FormHelperText error>
	                                      {formErrors[`${index}.BeforeVideo`] || ""}
	                                    </FormHelperText>
                                  </Grid>

	                        <Grid item md={2}>
	                          <TextField
	                            fullWidth
	                            label="After Clip(Sec)"
	                            type="number"
                                required
                                InputLabelProps={{ shrink: true }}
	                            value={formData.AfterVideo ?? ''}
	                            onChange={handleChange(index)("AfterVideo")}
	                            error={!!formErrors[`${index}.AfterVideo`]}
	                            // helperText={formErrors[`${index}.fps`] || ""}
	                          />
	                          <FormHelperText error>
	                            {formErrors[`${index}.AfterVideo`] || ""}
	                          </FormHelperText>
                        </Grid> 

                       {isReseller && ( <Grid item md={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="success"
                        checked={formData.HaveSpeaker === 1 ? true : false}
                        onChange={handleSwitchChange(index)("HaveSpeaker")}
                      />
                    }
                    label="Speaker"
                  />
                </Grid>)}  
                  </Grid>
            
              

            
              {!isReseller && (<Typography variant="subtitle2" sx={{ my: 2 }}>
                Camera Configuration
              </Typography>)}
             {(!isReseller && <Grid container spacing={2}>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="Camera Make"
                    InputLabelProps={{ shrink: true }}
                    value={formData.CameraMake}
                    onChange={handleChange(index)("CameraMake")}
                    // error={!!formErrors[`${index}.CameraMake`]}
                    // helperText={formErrors[`${index}.CameraMake`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="Camera Model"
                    InputLabelProps={{ shrink: true }}
                    value={formData.CameraModel}
                    onChange={handleChange(index)("CameraModel")}
                    // error={!!formErrors[`${index}.CameraModel`]}
                    // helperText={formErrors[`${index}.CameraModel`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="Local HTTP URL"
                    InputLabelProps={{ shrink: true }}
                    value={formData.LocalHTTPURL}
                    onChange={handleChange(index)("LocalHTTPURL")}
                    // error={!!formErrors[`${index}.LocalHTTPURL`]}
                    // helperText={formErrors[`${index}.LocalHTTPURL`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <TextField
                    fullWidth
                    label="Public HTTP URL"
                    InputLabelProps={{ shrink: true }}
                    value={formData.PublicHTTPURL}
                    onChange={handleChange(index)("PublicHTTPURL")}
                    // error={!!formErrors[`${index}.PublicHTTPURL`]}
                    // helperText={formErrors[`${index}.PublicHTTPURL`] || ""}
                  />
                </Grid>
                <Grid item md={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="success"
                        checked={formData.HaveSpeaker === 1 ? true : false}
                        onChange={handleSwitchChange(index)("HaveSpeaker")}
                      />
                    }
                    label="Speaker"
                  />
                </Grid>
              </Grid>)}
            </Card>
          )})}
        </DialogContent>
        <DialogActions>
          <Button color="error" variant="contained" onClick={onClose}>
            Close
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            onClick={handleSubmit}
            loading={isSubmitting}
            loadingIndicator={
              <CircularProgress 
                color="inherit" 
                size={24}  
              />
            }
          >
            Save
          </LoadingButton>
        </DialogActions>
      </Dialog>
    );
}
DeviceForm.propTypes = {
  setOpen: PropTypes.func.isRequired
} 
